<!--
    施工验收详情 - 交付报告详情
-->
<template>
    <div>
        <div class="content" v-if="bShowContent" :style="{'padding-bottom':isShowShare?'100px':'0'}">
            <div class="content_bg"></div>
            <div class="report_warp">
                <div class="report_tips report_tips_fin" v-if="objReport.fin_status != 1">
                    <div>尊敬的{{ objReport.name || '' }}：</div>
                    <div class="tips_text" v-html="objReport.head_tips"></div>
                </div>
                <div :class="{'people-fin':objReport.fin_status != 1}" class="people">
                    <!-- 监理 -->
                    <template v-for="(item, index) in objReport.responsible">
                        <div class="people_one">
                            <div class="people_one_left">
                                <div class="header_img">
                                    <img v-lazy="item.icon" alt="">
                                </div>
                                <div class="header_info">
                                    <div>监理</div>
                                    <div class="info_name">{{ item.name }}</div>
                                    <div class="work_card">工牌：{{ item.job_number }}</div>
                                </div>
                            </div>
                            <div class="people_one_right" v-if="item.qr_code" @click="setQrcode(item)">
                                <img src="@/assets/images/member/process/code_icon.png" alt="">
                            </div>
                        </div>
                    </template>
                    <template v-if="objReport.responsible && !objReport.responsible.length">
                        <div class="people_one">
                            <div class="people_one_left">
                                <div class="header_img">
                                    <img src="@/assets/images/archives/zhipai_icon.png" alt="">
                                </div>
                                <div class="header_info">
                                    <div>监理</div>
                                    <div class="info_name_dai" :style="{'--color':'#3D3C4F','--size':'28px'}">待指派</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="people_two">
                        <!-- 项目经理 -->
                        <template v-if="objReport.title != '采暖隐蔽系统施工监理报告'">
                            <template v-for="(item, index) in objReport.project_manager">
                                <div class="people_warp_item">
                                    <div class="people_one_left">
                                        <div class="header_img">
                                            <img v-lazy="item.icon" alt="">
                                        </div>
                                        <div class="header_info">
                                            <div>{{ item.rel_group_name }}</div>
                                            <div class="info_name">{{ item.name }}</div>
                                            <div class="work_card">工牌：{{ item.job_number }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="objReport.project_manager && !objReport.project_manager.length">
                                <div class="people_warp_item">
                                    <div class="people_one_left">
                                        <div class="header_img">
                                            <img src="@/assets/images/archives/zhipai_icon.png" alt=""></img>
                                        </div>
                                        <div class="header_info">
                                            <div>项目经理</div>
                                            <div class="info_name_dai" :style="{'--color':'#999999'}">待指派</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <!-- 施工人员 -->
                        <template v-if="!objReport.bPerson">
                            <template v-for="(item, index) in objReport.service_person">
                                <div class="people_warp_item">
                                    <div class="people_one_left">
                                        <div class="header_img">
                                            <img v-lazy="item.icon" alt="">
                                        </div>
                                        <div class="header_info">
                                            <div>{{ item.rel_group_name }}</div>
                                            <div class="info_name">{{ item.name }}</div>
                                            <div class="work_card">工牌：{{ item.job_number }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="objReport.service_person && !objReport.service_person.length">
                                <div class="people_warp_item">
                                    <div class="people_one_left">
                                        <div class="header_img">
                                            <img src="@/assets/images/archives/zhipai_icon.png" alt=""></img>
                                        </div>
                                        <div class="header_info">
                                            <div>施工员</div>
                                            <div class="info_name_dai" :style="{'--color':'#999999'}">待指派</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <!-- 验收合格图标 -->
                    <div class="fin_status" v-if="objReport.fin_status == 1">
                        <img src="@/assets/images/member/process/hege_icon.png" alt="">
                    </div>
                </div>

                <div class="report_item"
                     v-for="(item, index) in objReport.process" :key="index">
                    <div class="report_item_title">
                        <span class="span_title">
                            {{ item.title }}
                        </span>
                        <span class="span_test">
                            {{ item.quality_point_title }}
                            <!--                            <i :class="item.bCateOpen ? '' : 'open_test'"></i>-->
                        </span>
                    </div>
                    <div class="report_item_warp">
                        <div class="report_item_warp_text" v-if="item.tips">
                            {{ item.tips }}
                        </div>
                        <div
                            :class="['report_item_nav', item.tag_list.constructor == Object ? 'item_nav_center' : '']">
                            <div :class="['nav_item', item.nCateTag == sumitem.tag_id ? 'atv_nav_item' : '']"
                                 v-for="(sumitem, sumindex) in item.tag_list" :key="sumindex"
                                 @click.stop="cliclTag(item, sumitem)">
                                {{ sumitem.tag_name }}
                            </div>
                        </div>
                        <div class="swiper_img"
                             v-if="item.photo_list.constructor == Object && item.photo_list[item.nCateTag] && item.photo_list[item.nCateTag].length">
                            <van-swipe :show-indicators="false" :ref="'vanSwiper' + index" :loop="true"
                                       @change="swipetwo($event, item)">
                                <van-swipe-item v-for="(attitem, attindex) in item.photo_list[item.nCateTag]"
                                                :key="attindex">
                                    <div class="swipe_img_url"
                                         @click="getShow(item.photo_list[item.nCateTag],attindex,index)">
                                        <img v-lazy="attitem" alt="">
                                    </div>
                                </van-swipe-item>
                            </van-swipe>
                            <div class="img_tips">{{ item.photo_text }}</div>
                            <div class="swiper_point">
                                <div :class="[item.nCateTagSwiper == poinindex ? 'color_point' : '']"
                                     v-for="(poinitem, poinindex) in item.photo_list[item.nCateTag]" :key="poinindex">
                                </div>
                            </div>
                        </div>
                        <div class="swiper_list_sm"
                             v-if="item.photo_list.constructor == Object && item.photo_list[item.nCateTag] && item.photo_list[item.nCateTag].length">
                            <div class="swiper_list_scroll">
                                <div :class="['swiper_list_item', item.nCateTagSwiper == attindex ? 'click_item' : '']"
                                     v-for="(attitem, attindex) in item.photo_list[item.nCateTag]" :key="attindex"
                                     @click="getShow(item.photo_list[item.nCateTag],attindex,index)">
                                    <img v-lazy="attitem" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="line"
                             v-if="item.acceptance_line[item.nCateTag] && item.acceptance_line[item.nCateTag].length"></div>
                        <div class="tabble"
                             v-if="item.acceptance_line[item.nCateTag] && item.acceptance_line[item.nCateTag].length">
                            <div class="tabble_h">
                                <div class="tabble_h_one">验收质控点</div>
                                <div class="tabble_h_two">施工标准</div>
                                <div class="tabble_h_three">验收结果</div>
                            </div>
                            <template v-for="(attitem, attindex) in item.acceptance_line[item.nCateTag]">
                                <div class="tabble_d" v-if="item.bCateOpen?true:attindex<3">
                                    <div class="tabble_display">
                                        <div class="tabble_d_one" :class="{'tabble_d_one_active':attitem.is_right==1}">
                                        <span v-html="attitem.title">
                                        </span>
                                        </div>
                                        <div class="tabble_d_two">
                                            <span>{{ attitem.standard_answer }}</span>
                                        </div>
                                        <div class="tabble_d_three">
                                            <span>{{ attitem.answer_result }}</span>
                                        </div>
                                    </div>
                                    <div class="help_tips" v-if="attitem.selling_points != ''">
                                        {{ attitem.selling_points }}
                                    </div>
                                </div>
                            </template>

                        </div>
                        <div class="open_close"
                             v-if="item.acceptance_line[item.nCateTag] && item.acceptance_line[item.nCateTag].length>3"
                             @click="openCloseYs(item)">
                            <img src="@/assets/images/processv2/open-close.png" alt=""
                                 :style="{'transform':item.bCateOpen?'rotate(0deg)':'rotate(180deg)'}">
                            <span>{{ item.bCateOpen ? '收起' : '展开显示更多' }}</span>
                        </div>
                    </div>
                </div>
                <div class="report_tips" v-if="objReport.fin_status == 1">
                    <div class="tip-red">监理特别提醒：</div>
                    <div class="tips_text" v-html="objReport.head_tips"></div>
                </div>
                <!--                <div class="doubt" v-if="objReport.fin_status==1"-->
                <!--                     @click="objReport.project_manager && objReport.project_manager.length ? setQrcode(objReport.project_manager[0]) : ''">-->
                <!--                     <span>-->
                <!--                        有疑问-->
                <!--                    </span>-->
                <!--                </div>-->
            </div>
            <!--            <div class="bottom_btn" v-if="$route.query.completed == 1 && objReport.fin_status == 0 && !isShowShare">-->
            <!--                <div @click="submit">验收</div>-->
            <!--            </div>-->
            <qrcodePopup :nPopup.sync="bPopup" :nEwmImg="nEwmImg" :nTitle="stausName"></qrcodePopup>
            <!-- 预览图片 -->
            <van-image-preview v-model="imgShow" :closeable="true" :startPosition="lookImgIndex" @change="imageChange"
                               :images="arrStausImg"></van-image-preview>
        </div>

        <div class="home_icon" @click="toHome" :style="{bottom: isShowShare ? '108px':'88px'}">
            <img src="~@/assets/images/processv2/tohome.png"/>
        </div>

        <share ref="myShare" v-if="isShowShare" :isHouse="false" :title="'史密斯-设计师'"
               :isFixed="true"></share>
    </div>
</template>

<script>
import qrcodePopup from "../components/qrcode.vue";
import share from "../components/share.vue";
import {getProcessDetails} from "@/js/designer/index.js";

export default {
    name: 'designerProcess',
    components: {
        qrcodePopup,
        share
    },
    data() {
        return {
            isShowShare: false,//是否显示分享
            nEwmImg: '',
            imgShow: false,
            bPopup: false,
            arrStausImg: [],
            stausName: '',
            lookImgIndex: 0,
            nBgCateIndex: 0,
            nCate: 0,
            objReport: {
                responsible: [],
                fin_status: 0,
                head_tips: '',
                service_supervisor: [],
                service_person: [],
                project_uuid: ',',
                bPerson: false,
            },
            bShowContent: false,
        }
    },
    created() {
        this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启

        $init(() => {
            this.$oInitData.designerInfo({
                h5_user_id: this.$storage.getStorage("user_id"),
            }).then((res) => {
                let objData = this.$route.query;
                if (objData.sampleroom == 2) {
                    this.isShowShare = true;
                }
                this.getMeberInfo();
            }).catch((error) => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            });
        })
    },
    methods: {
        toHome() {
            this.$router.go(-2)
        },
        openCloseYs(item) {
            item.bCateOpen = !item.bCateOpen
        },
        // 交付详情
        getMeberInfo() {
            let _that = this;
            _that.$store.commit("loadSwitch", true);
            getProcessDetails({
                rule_report_id: _that.$route.query.id,
                projectmgnid: _that.$storage.getStorage('designer_prject').new_srv_projectmgnid,
                sampleroom: _that.$route.query.sampleroom || '',
            }).then(res => {
                _that.$store.commit("loadSwitch", false);
                _that.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                let objReport = res.data.result;
                if (objReport.process && objReport.process.length > 0) {
                    objReport.process.forEach((it, index) => {
                        if (it.tag_list.length) {
                            it.nCateTag = it.tag_list[0].tag_id;
                            it.nCateTagSwiper = 0;
                        }
                        if (it.acceptance_line[it.nCateTag].length > 3) {
                            it.bCateOpen = false;
                        } else {
                            it.bCateOpen = true;
                        }
                    })
                }
                _that.bShowContent = true;
                objReport.head_tips = objReport.head_tips.replace(/[\r\n]/g, "<br>");
                console.log(objReport, 'objReport')
                if (objReport.title == '采暖隐蔽系统施工监理报告' && objReport.fin_status == 1 && objReport.service_supervisor && !objReport.service_supervisor.length) {
                    objReport.responsible = objReport.project_manager;
                    if ((objReport.responsible.length && objReport.responsible[0].job_number) == (objReport.service_person.length && objReport.service_person[0].job_number)) {
                        objReport.bPerson = true;
                    } else {
                        objReport.bPerson = false;
                    }
                } else {
                    objReport.responsible = objReport.service_supervisor;
                    objReport.bPerson = false;
                }
                _that.objReport = objReport;
                document.title = objReport.title
            })
        },
        cliclTag(item, sumitem) {
            item.nCateTag = sumitem.tag_id;
        },
        swipetwo(e, item) {
            item.nCateTagSwiper = e;
        },
        //确认验收
        // submit() {
        //     this.$router.push(`/user/house/v2/finish?company_id=${this.objReport.company_id}&contract_id=${this.objReport.contract_id}&project_uuid=${this.objReport.project_uuid}`)
        // },
        setQrcode(item) {
            this.bPopup = true;
            this.stausName = item.name;
            this.nEwmImg = item.qr_code;
        },
        getShow(e, num, index) {
            this.nBgCateIndex = index;
            this.lookImgIndex = num;
            this.imgShow = true;
            this.arrStausImg = e;
        },
        imageChange(e) {
            this.$refs['vanSwiper' + this.nBgCateIndex][0].swipeTo(e);
            this.nCateTagSwiper = e;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>
